import moment from 'moment';

export const PaymentStatus = {
  OVERDUE: 'Overdue',
  UNDUE:   'Upcoming Payment Due'
}

export const currentDateDiffStatus =  payment  => {
  // Note: You may use / improve
  // this for overdue payment date diff
  const { due_date } = payment
  return evaulateDateDiffCopy(due_date);
};

export const evaulateDateDiffCopy = date => {
  const numberOfDaysLeft = calculateDateDiff(date);
  const due_soon_limit = 5;
  const current_date_count = 0;

  if (numberOfDaysLeft <= due_soon_limit && numberOfDaysLeft > current_date_count) {
    return 'Due Soon'
  } else if (numberOfDaysLeft > due_soon_limit) {
    return  `In ${numberOfDaysLeft} Days`
  } else if (numberOfDaysLeft ===  current_date_count) {
    return 'Due Today'
  } else {
    return 'Pending'
  }
};

export const calculateDateDiff = date => {
 const dateToday         = moment().startOf('day');
 const dueDate           = moment(date, "YYYY-MM-DD");
 const numberOfDaysLeft  = dueDate.diff(dateToday, 'days');

 return numberOfDaysLeft;
};



// WEBPACK FOOTER //
// ./src/features/shared/utils/PaymentStatus.js